// Visual da tela final de sucesso, compartilhado entre o Protocolo Online
// (modules/protocolo) e os pedidos do wizard de Requerimentos
// (modules/requerimentos) — card verde, painel branco com linhas "rótulo: valor"
// e grupo de botões embaixo.
import styled from 'styled-components';
import { colors } from '../../../assets/styles/GlobalStyles';

const FONTE = "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

export const SuccessCard = styled.div`
  border-radius: 20px;
  padding: 2rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  text-align: center;
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border: 1px solid #bbf7d0;

  @media (max-width: 768px) {
    padding: 1.5rem 1rem;
  }
`;

export const SuccessTitle = styled.h2`
  font-size: 1.3rem;
  font-weight: 600;
  color: #16a34a;
  margin-bottom: 1.5rem;
  font-family: ${FONTE};
`;

export const SuccessInfoPanel = styled.div`
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  margin-top: 1rem;
  text-align: left;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const SuccessInfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 0.6rem 0;
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.95rem;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.3rem;
    align-items: flex-start;
  }
`;

export const SuccessInfoLabel = styled.span`
  font-weight: 500;
  color: #475569;
  font-size: 0.9rem;
`;

export const SuccessInfoValue = styled.span`
  color: ${({ $cor }) => $cor || '#1e293b'};
  font-weight: ${({ $cor }) => ($cor ? 700 : 500)};
  font-size: 0.9rem;
  text-align: right;
  overflow-wrap: anywhere;

  @media (max-width: 768px) {
    text-align: left;
  }
`;

// Número em destaque (protocolo/requerimento), em "etiqueta" branca
export const SuccessNumero = styled.div`
  font-size: 1rem;
  font-weight: 700;
  color: ${colors.darkBlue};
  font-family: ${FONTE};
  margin: 0.5rem 0;
  letter-spacing: 1px;
  background: white;
  display: inline-block;
  padding: 0.3rem 1rem;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const SuccessMessage = styled.p`
  text-align: center;
  color: ${colors.textMuted};
  margin: 1.5rem 0 1rem 0;
  font-size: 0.9rem;
`;

export const SuccessButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
  justify-content: center;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
